import purchaseHistoryService from '../../services/purchaseHistoryService'
import Vue from "vue";
import {distinctById} from "../../utils";

const state = {
    histories: [],
    histories_loading: false,
    next_page: 1,
};

const actions = {
    getPurchaseHistory(store, params) {
        return new Promise((resolve, reject) => {
            purchaseHistoryService.getPurchaseHistory(params)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию об истории закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                })
        })
    },
    getPurchaseHistories({commit, state}, params) {
        if (!state.next_page) {
            return
        }
        state.histories_loading = state.next_page === 1;
        params.page = state.next_page;
        return new Promise((resolve, reject) => {
            purchaseHistoryService.fetchPurchaseHistory(params)
                .then(response => {
                    let histories = distinctById(state.histories.concat(response.results));
                    commit('setHistories', {next: response.next, histories});
                    state.histories_loading = false;
                    resolve();
                })
                .catch(error => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось получить информацию об истории закупки.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.histories_loading = false;
                    reject();
                })
        })
    },
};

const mutations = {
    setHistories(state, {next, histories}) {
        if (next) {
            state.next_page += 1;
        } else {
            state.next_page = null;
        }
        state.histories = histories;
    },
    clearData(state) {
        state.next_page = 1;
        state.histories = [];
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}